export default __webpack_public_path__ + "static/media/member.8fd8fec8.png";